import { Component, OnInit, HostListener } from '@angular/core';
import { DepositoService } from 'src/app/services/deposito.service';
import { IntencaoDeposito } from 'src/app/models/intencao-deposito';
import { Auth } from 'src/app/models/auth';
import { AuthenticationService } from 'src/app/services/authentication.service';

import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { TransactionService } from 'src/app/services/transaction.service';
import { ColaboradorFilterOptions } from 'src/app/shared/helpers/models/colaborador-filter-options';
import { IntencaoDepositoFilterOptions } from 'src/app/shared/helpers/models/intencao-deposito-filter-options';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IntencaoDepositoDetalhes } from 'src/app/models/intencao-deposito-detalhes';
import { GerarBoletoCadastro } from 'src/app/models/gerar-boleto-cadastro';
import { ReciboIntencaoDeposito } from 'src/app/models/recibo-intencao-deposito';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { Router } from '@angular/router';
import { VisualizarBoletoService } from '../../../visualizar-boleto/visualizar-boleto.service';
import { GerarPixDinamico } from 'src/app/models/request/gerar-pix-dinamico';
import { QRCodePixDinamico } from 'src/app/models/response/pix-qrcode';
import { BRCodePix } from 'src/app/models/response/brcode-pix';
import { Assignor } from 'src/app/models/assignor';

@Component({
  selector: 'app-pagamentos-list',
  templateUrl: './pagamentos-list.component.html',
  styleUrls: ['./pagamentos-list.component.css']
})
export class PagamentosListComponent implements OnInit {

  constructor(
    private transactionservice: TransactionService,
    private depositoService: DepositoService,
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    private modalService: NgbModal,
    private visualizarBoletoService: VisualizarBoletoService,
    private router: Router) {
    this.onResize();
  }

  public intencoesDeposito: IntencaoDeposito[] = [];
  private currentUser: Auth;
  public isMobile = false;
  public sortOrder: boolean;

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;

  // filtro pesquisa
  public filtroPesquisa = '';

  // objetos de modal

  public intencaoDepositoDetalhes: IntencaoDepositoDetalhes = null;

  public filtroCodigo = '';
  public filtroIdentificador = '';
  public filtroValor = '';
  public filtroDataCadastro = '';
  public filtroDataProcessamento = '';
  public filtroDataCancelamento = '';

  // pix
  protected depositoSelecionadoId: string;
  protected btnEnviarEnable: boolean = false;
  public depositoPixRequest: GerarPixDinamico;
  public assignorInfo: Assignor;
  public qrCodePix: QRCodePixDinamico;
  public brCodePix: BRCodePix;

  public reciboIntencaoDeposito: ReciboIntencaoDeposito = null;

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    this.pageChanged(this.currentPage);
    /*this.depositoService.getAllPaged(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.intencoesDeposito = response.result;
          // teste depois pegar da model
          this.totalItems = this.intencoesDeposito.length;
          console.log(this.intencoesDeposito);
        } else {
          this.alertService.error(response.message);
        }
      },
      error => {
        this.alertService.error('Erro ao consultar intenções de depósito');
      }
    );*/

    // teste
    this.depositoService.getTiposDeposito().subscribe(
      response => {
        /* console.log(response) */
      }
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.isMobile = window.innerWidth <= 500;
  }

  orderBy(collumnName: string, sortOrder: boolean) {
    this.intencoesDeposito.sort((a, b) => {
      const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
      const aVal = (a[collumnName] === null
        ? dftl
        : a[collumnName]
      ).toString();
      const bVal = (b[collumnName] === null
        ? dftl
        : b[collumnName]
      ).toString();
      let result = aVal.localeCompare(bVal, undefined, { numeric: true });
      if (sortOrder) {
        result = bVal.localeCompare(aVal, undefined, { numeric: true });
      }

      return result;
    });
  }

  pageChanged(event) {
    this.currentPage = event;
    const offset = (this.currentPage - 1) * +this.showItem;

    const filterOptions = new IntencaoDepositoFilterOptions();
    filterOptions.q = this.filtroPesquisa;

    filterOptions.codigo = this.filtroCodigo;
    filterOptions.identificador = this.filtroIdentificador;
    /*filterOptions.valor = this.filtroValor;
    filterOptions.datacadastro = this.filtroDataCadastro;
    filterOptions.dataprocessamento = this.filtroDataProcessamento;
    filterOptions.datacancelamento = this.filtroDataCancelamento;*/

    this.alertService.clear();
    this.depositoService
      .getAllPaged(
        this.currentUser.token.assignorGuid,
        this.currentUser.token.userReferenceId,
        offset,
        +this.showItem,
        filterOptions,
        null
      )
      .subscribe(
        response => {
          if (response.status === ApiError.Sucesso) {
            this.intencoesDeposito = response.result.itens;
            this.totalItems = response.result.total;
          } else {
            this.alertService.error(response.message);
          }
        },
        error => {
          this.alertService.error('Ocorreu um erro ao paginar as instenções de depósito');
        }
      );
  }

  showItemChanged(event) {
    this.showItem = event;
    this.pageChanged(1);
  }

  showVisualizarIntencaoDeposito(content: any, intencaoDepositoGuid: string) {
    // chamar api
    this.depositoService.getDetails(intencaoDepositoGuid, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.intencaoDepositoDetalhes = response.result;
          this.modalService.open(content, { centered: true, size: 'lg' });
        } else {
          this.alertService.error(response.message);
        }
      }, error => {
        this.alertService.error('Ocorreu um erro ao visualizar intenção de depósito');
      }
    );
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  applyFilter(
    codigo: string,
    identificador: string,
    valor: string,
    dataCadastro: string,
    dataProcessamento: string,
    dataCancelamento: string
  ) {
    this.filtroCodigo = codigo;
    this.filtroIdentificador = identificador;
    this.filtroValor = valor;
    this.filtroDataCadastro = dataCadastro;
    this.filtroDataProcessamento = dataProcessamento;
    this.filtroDataCancelamento = dataCancelamento;

    this.pageChanged(1);
  }

  showQRCodePagar(content: any, intencaoDepositoId: string, brCodePIX: BRCodePix) {
    this.depositoSelecionadoId = intencaoDepositoId;
    this.brCodePix = new BRCodePix();
    /* console.log(brCodePIX) */
    this.brCodePix = brCodePIX;
    if(brCodePIX == null)
      this.alertService.error('Ocorreu um erro ao visualizar o QR Code');
    else{
      this.btnEnviarEnable = false;
      this.modalService.open(content, { centered: true, size: 'lg' });
    }
  }

  gerarBoleto(item: IntencaoDeposito) {
    this.depositoService.generateBoleto(item.intencaoDepositoGuid, new GerarBoletoCadastro(item.valor, null), this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          // item.boletoInfo = response.result;
          // window.open(response.result.pdf, '_blank');
          this.visualizarBoletoService.arquivoBase64 = response.result.pdf;
          this.router.navigate(['portal/boleto']);
        } else {
          this.alertService.error(response.message);
        }
      }, error => {
        this.alertService.error('Ocorreu um erro ao gerar boleto');
      }
    );
  }

  showVisualizarBoleto(item: IntencaoDeposito) {
    this.visualizarBoletoService.arquivoBase64 = item.boletoInfo.pdf;
    this.router.navigate(['portal/boleto']);
  }

  showVisualizarReciboIntencaoDeposito(content: any, intencaoDepositoGuid: string) {
    // chamar api
    this.depositoService.getRecibo(intencaoDepositoGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.reciboIntencaoDeposito = response.result;
          this.modalService.open(content, { centered: true, size: 'lg' });
        } else {
          this.alertService.error(response.message);
        }
      }, error => {
        this.alertService.error('Ocorreu um erro ao obter recibo');
      }
    );
  }
}
